import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import RegisterForm from './RegisterForm'
import DriverForm from './DriverForm'
import Resume from '../Resume'
import { Box, Flex, Button, Copy, Icon } from '@elparking/components'
import ResumeContainer from '../Resume/ResumeContainer'
import SimpleModal from '../Modals/SimpleModal'
import { useApi } from '@elparking/utils'
import ShareModal from '../Modals/ShareModal'
import reloadRentalCarSearch from 'commons/js/api/rentalCar/reloadRentalCarSearch'
import { FormattedMessage } from 'react-intl'
import scrollTo from 'commons/js/util/scrollTo'

const Step4 = ({
    id,
    share,
    user,
    userLoaded,
    driver,
    uuid,
    updateDriver,
    onNext,
    publicToken,
    oAuthToken,
    onBack,
    reloadRentalCarSearch,
    loading: contractLoading,
    reload,
    scrollTo,
    setOnCloseModal,
}) => {
    const [ showShareModal, setShowShareModal ] = useState(false)
    const {
        response: { result: mustReload, error },
        loading,
        sendRequest: reloadUser,
    } = useApi(reloadRentalCarSearch)

    useEffect(() => {
        if (userLoaded && oAuthToken && uuid && id && user) {
            reloadUser({ uuid, id, token: oAuthToken })
        }
    }, [userLoaded, oAuthToken, uuid, id, reloadUser, user])

    useEffect(() => {
        scrollTo(1)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return <Box width='100%'>
        {mustReload && <SimpleModal
          isShown
          showCloseButton={false}
          imageSrc='/images/rental-car/sign-up-verification.svg'
          onAccept={reload}
          title={<FormattedMessage defaultMessage='El precio de tu alquiler ha cambiado' />}
          subtitle={<FormattedMessage defaultMessage='Por favor, vuelve al listado de resultados ya que los precios de los vehículos disponibles han cambiado.' />}
          acceptButtonText={<FormattedMessage defaultMessage='Volver a resultados' />}
        />}
        {showShareModal && <ShareModal unbornId={id} uuid={uuid} onClose={() => setShowShareModal(false)}/>}
        {!!error && <SimpleModal
          isShown
          showCloseButton={false}
          imageSrc='/images/rental-car/cancel-booking.svg'
          onAccept={onBack}
          title={<FormattedMessage defaultMessage='Se ha producido un error' />}
          subtitle={<FormattedMessage defaultMessage='Por favor realiza de nuevo la búsqueda' />}
        />}
        <Flex gridGap='20px' mt={['1em', '2em']} flexDirection={['column', 'column', 'row']} p={['0', '0', '0 1em']}>
            <Box width={['100%', '100%', 'calc(100% - 330px)']}>
                {(!userLoaded || !user)
                    ? <RegisterForm />
                    : <DriverForm share={share} setOnCloseModal={setOnCloseModal} user={user} loading={loading || contractLoading} driver={driver} onSubmit={(values) => {
                        updateDriver(values)
                        if (userLoaded && !loading && !contractLoading) {
                            const data = values.sameDriver
                                ? {
                                    firstName: values.firstName,
                                    lastName: values.lastName,
                                    mobileNumber: values.phone,
                                    birthDate: values.birthday,
                                } : {
                                    firstName: values.otherFirstName,
                                    lastName: values.otherLastName,
                                    mobileNumber: values.otherPhone,
                                    birthDate: values.otherBirthday,
                                    email: values.otherEmail,
                                }
                            onNext({
                                ...data,
                                token: oAuthToken || publicToken,
                                id,
                                uuid,
                                flightNumber: values.fly,
                                trainNumber: values.train,
                                acceptedTerms: true,
                            })
                        }
                    }} />
                }
                {(!userLoaded || !user) && (share === 'true') && <Copy padding='2em 0' textAlign='right'>
                    <Button.bordered backgroundColor='darkMain' hoverBackgroundColor='darkMain80' with='100%' fontColor='white' onClick={() => setShowShareModal(true)}>
                        <FormattedMessage defaultMessage='Compartir' /> <Icon type='up-right' />
                    </Button.bordered>
                </Copy>}
            </Box>
            <Box display={['none', 'none', 'block']} width='330px'>
                <ResumeContainer>
                    <Resume />
                </ResumeContainer>
            </Box>
        </Flex>
    </Box>
}

Step4.defaultProps = {
    share: false,
    loading: false,
    userLoaded: false,
    updateDriver: () => {},
    setOnCloseModal: () => {},
    reloadRentalCarSearch,
    scrollTo,
}

Step4.propTypes = {
    setOnCloseModal: PropTypes.func,
    scrollTo: PropTypes.func,
    publicToken: PropTypes.any,
    oAuthToken: PropTypes.any,
    driver: PropTypes.object,
    loading: PropTypes.bool,
    user: PropTypes.object,
    reloadRentalCarSearch: PropTypes.func.isRequired,
    updateDriver: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    userLoaded: PropTypes.bool,
    uuid: PropTypes.string.isRequired,
    id: PropTypes.any.isRequired,
    reload: PropTypes.func,
    share: PropTypes.bool,
}

export default Step4
